import Vue from 'vue'
import Autocomplete from '@trevoreyre/autocomplete-vue'

Vue.config.productionTip = false;

export default {
    name : 'headerSearch',
    _selector : '#js_headerSearch',
    init() {
        const el = document.querySelector(this._selector);

        if (!el) {
            return false;
        }

        this.run();
    },

    run() {
        new Vue({
            el: this._selector,

            delimiters: ['@{', '}'],

            data :
            {
                host : "",
                resource  : "actions/tellus/search/index",
                isSearchToggled : false,
                input : "",
                items : [],
                link  : "",
            },

            components:
            {
                Autocomplete
            },

            computed :
            {
                searchToggledClass()
                {
                    return (this.isSearchToggled) ? ' active ' : '';
                }
            },

            methods:
            {
                toggleSearch()
                {
                    this.isSearchToggled = !this.isSearchToggled;
                },

                submitForm(event)
                {
                    event.preventDefault();
                    if (this.link !== "") {
                        location.href = this.link;
                    }
                },

                getResultValue(item)
                {
                    this.link = item.link;
                    return item.title;
                },

                search(input)
                {
                    this.input = input;
                    return this.getItems();
                },

                getItems()
                {
                    const url = this.host+this.resource+"?q="+this.input;

                    return new Promise(resolve => {
                        if (typeof this.input === "undefined" || !this.input || this.input.length < 3) {
                            return resolve([]);
                        }

                        fetch(url)
                            .then(response => response.json())
                            .then(data => {
                                resolve(data.items);
                            });
                        }
                    );
                },
            },
            created ()
            {
                this.host = document.querySelector('[name="site_root"]').content;
            }

      });

    }
}